import React from 'react';
import ReactDOM from 'react-dom';
import {
  ApolloClient,
  HttpLink,
  ApolloLink,
  InMemoryCache,
  ApolloProvider,
  concat
} from "@apollo/client";

import ReturnsMain from '../returns/returns_main';
const mountNode = document.getElementById('returns-flow');

const csReturn = mountNode.dataset.csReturn  === 'true';
const useInPostRetailerPageNewCopy =
  mountNode.dataset.inPostRetailerPageNewCopy === 'true';
const useInPostReturnsRemoveMarketingCheckbox =
  mountNode.dataset.inPostReturnsRemoveMarketingCheckbox === 'true';

const retailer = {
  
  name: mountNode.dataset.retailerName,
  slug: mountNode.dataset.retailerSlug,
  address: mountNode.dataset.retailerAddress,
  enablePrintInStore: mountNode.dataset.retailerEnablePrintInStore  === 'true',
  enablePrintAtHome: mountNode.dataset.retailerEnablePrintAtHome  === 'true',
  unlabelledInpostLockers: mountNode.dataset.retailerUnlabelledInpostLockers === 'true',
  labelledInpostLockers: mountNode.dataset.retailerLabelledInpostLockers === 'true',
  providesBoxLabel: mountNode.dataset.retailerProvidesBoxLabel  === 'true',
  printInStorePrice: mountNode.dataset.retailerPisPrice,
  retailerIntroduction: mountNode.dataset.retailerIntroduction,
  retailerDimensions: mountNode.dataset.retailerDimensions,
  retailerPreFormContent: mountNode.dataset.retailerPreFormContent,
  retailerPostFormContent: mountNode.dataset.retailerPostFormContent,
  retailerShowPageTemplate: mountNode.dataset.retailerShowPageTemplate,
}

let yodelReturn = null;
if (mountNode.dataset.returnGuid) {
  yodelReturn = {
    guid: mountNode.dataset.returnGuid,
    printInStore: mountNode.dataset.isPrintInStore  === 'true',
    isLabelAvailable: mountNode.dataset.isLabelAvailable === 'true',
    userEmail: mountNode.dataset.returnUserEmail,
    csGenerated: mountNode.dataset.isCsGenerated === 'true',
    csUser: mountNode.dataset.csUser,
    isInpostLocker: mountNode.dataset.isInpostLockers === 'true',
    unlabelledInpostLocker: mountNode.dataset.isUnlabelledLockers === 'true',
  }
}

const csrfToken = document.querySelector('meta[name="csrf-token"]') &&
  document.querySelector('meta[name="csrf-token"]').getAttribute("content");
const httpLink = new HttpLink({ uri: '/graphql' });
const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'X-CSRF-Token': csrfToken,
    }
  }));

  return forward(operation);
});

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
  },
  query: {
    fetchPolicy: 'no-cache',
  }
};
const client = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache(),
  defaultOptions: defaultOptions,
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <ReturnsMain
      csReturn={csReturn}
      retailerInitialData={retailer}
      yodelReturn={yodelReturn}
      useInPostRetailerPageNewCopy={useInPostRetailerPageNewCopy}
      useInPostReturnsRemoveMarketingCheckbox={useInPostReturnsRemoveMarketingCheckbox}
    />
  </ApolloProvider>,
  mountNode
);
